"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Service_1 = require("../Service");
var Util_1 = require("../../Utils/Util");
/**
 * Represents the dlist.gg service.
 * @see https://api.discordlist.gg/developers/
 */
var DList = /** @class */ (function (_super) {
    __extends(DList, _super);
    function DList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DList, "aliases", {
        /** The values that can be used to select the service. */
        get: function () {
            return ['dlistgg', 'dlist.gg', 'discordlistgg', 'discordlist.gg'];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DList, "logoURL", {
        /** The logo URL. */
        get: function () {
            return 'https://avatars.githubusercontent.com/u/68995595';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DList, "serviceName", {
        /** Service's name. */
        get: function () {
            return 'dlist.gg';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DList, "websiteURL", {
        /** The website URL. */
        get: function () {
            return 'https://discordlist.gg';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DList, "baseURL", {
        /** The base URL of the service's API. */
        get: function () {
            return 'https://api.discordlist.gg/v0';
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Posts statistics to this service.
     * <warn>Shard data posting is not supported for this service.</warn>
     * @param options The options of the request.
     */
    DList.post = function (options) {
        var token = options.token, clientID = options.clientID, serverCount = options.serverCount;
        return _super._post.call(this, {
            method: 'put',
            url: "/bots/".concat(Util_1.Util.resolveID(clientID), "/guilds"),
            headers: { Authorization: "Bearer ".concat(token) },
            params: {
                count: Util_1.Util.resolveCount(serverCount)
            }
        });
    };
    return DList;
}(Service_1.Service));
exports.default = DList;
